// extracted by css-extract-rspack-plugin
export default {"root":"EventLayout_root__eZ6EC","options":"EventLayout_options__kyXPo","content":"EventLayout_content__myroS","header":"EventLayout_header__-7HmI"};